/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of PrintablesList
 * Alfapeople -Customisation object -For about us page
 */

import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
export interface IPage {
  pageHeading?: string;
  pageContent?: string;
}

/**
 *
 * AboutUs component
 * @extends Component
 */
export class AboutUs extends Component {
  private readonly aboutUsPage: IPage = {
    pageHeading: 'About us',
    pageContent:
      'With more than 70 years in the toy business and 700+ stores worldwide, Toys“R”Us®️ is known as the toy authority for generations of parents and children alike.<br>Marketing Services and Commercial Projects Operation Company (Tasweeq) is the sole franchisee of Toys R Us in Saudi Arabia. We started our operations in 1996 with our first location in Riyadh. Since commencing our operations, we reinforced our presence in Saudi Arabia with a network of 17 stores across Riyadh, Jeddah, Dhahran, Dammam, Al Ahsa, Abha, Al Madina, Makkah, Al Taif<br>To ensure a happy shopping experience for customers, we offer more than 20,000 of the best toys, games, indoor and outdoor sporting goods, figurines, building blocks, puzzles, board games, remote-controlled cars, dolls, art and craft toys, role play costumes and many other classic toys that inspire creativity and develop cognitive skills.<br><br>',
  };
  public render(): JSX.Element | null {
    return (
      <div className='row'>
        <div className='static-page-container'>
          <div className='col-lg-12 col-md-12'>
            <h1 className='about-us-page-heading'>
              {this.aboutUsPage.pageHeading}
            </h1>
          </div>
          <div className='col-lg-12 col-md-12'>
            <p className='about-us-page-description'>
              {ReactHtmlParser(this.aboutUsPage.pageContent)}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default AboutUs;
